import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import styles from "./activityCards.module.css";
import { testUrl } from "../BaseData";
import Pagination from "@mui/material/Pagination";

const Bitiruvchilar = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [alumni, setAlumni] = useState([]);
    const [pageApi, setPageApi] = useState(1);
    const itemsPerPage = 9;

    useEffect(() => {
        setLoading(true);
        setError(null);

        // Fetch all activity types to dynamically find the short_name for "Bizning bitiruvchilar"
        axios.get(testUrl + "/api/activitiestype/")
            .then((res) => {
                const types = res.data;
                const targetType = types.find(type =>
                    (type.name_uz && type.name_uz.toLowerCase().includes("bitiruvchi")) ||
                    (type.name_ru && type.name_ru.toLowerCase().includes("bitiruvchi")) ||
                    (type.name_en && type.name_en.toLowerCase().includes("bitiruvchi")) ||
                    type.name_uz === "Bizning bitiruvchilar"
                );

                const shortName = targetType && targetType.short_name ? targetType.short_name : "bizning-bitiruvchilar";
                return axios.get(testUrl + `/api/activities/${shortName}/`);
            })
            .then((response) => {
                if (response && response.data) {
                    setAlumni(response.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching bitiruvchilar faoliyat:", err);
                setError("Ma'lumotlarni yuklashda xatolik");
            })
            .finally(() => setLoading(false));

    }, [i18n.language]);

    const indexOfLastItem = pageApi * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentAlumni = alumni.slice(indexOfFirstItem, indexOfLastItem);

    if (loading) return <div>Yuklanmoqda...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div className={classes["mainContainer"]}>
            <div data-aos="fade-up" className={classes["container"]}>
                <h1 className={classes["page-title"]}>{t("Bizning bitiruvchilar")}</h1>
                <div className={styles.facultyGrid}>
                    {currentAlumni.filter(Boolean).map((item) => (
                        <div
                            key={item.id}
                            className={styles.activityCard}
                            onClick={() => navigate(`/activity/${item.id}`)}
                        >
                            <img src={item.image} alt=" " className={styles.activityImage} />
                            <div className={styles.activityInfo}>
                                <h3>{item[`name_${i18n.language}`] || item.name_uz}</h3>
                            </div>
                        </div>
                    ))}
                </div>
                {alumni.length > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0' }}>
                        <Pagination
                            onChange={(e, value) => setPageApi(value)}
                            count={Math.ceil(alumni.length / itemsPerPage)}
                            page={pageApi}
                            variant="outlined"
                            shape="rounded"
                        />
                    </div>
                )}
            </div>
            <div className={classes.sidebar}>
                <h3>{t("Talabalarga")}</h3>
                <ul>
                    <li onClick={() => navigate("/baseactivities/talabalar-hayoti/")}>
                        {t("Talabalar hayoti")}
                    </li>
                    <li onClick={() => navigate("/activity/talabalarga/karyera/")}>
                        {t("Karyera")}
                    </li>
                    <li onClick={() => navigate("/university-union")}>
                        {t("universityUnion")}
                    </li>
                    <li onClick={() => navigate("/activity/talabalarga/talabalar-turar-joyi")}>
                        {t("Talabalar turar joyi")}
                    </li>
                    <li onClick={() => navigate("/activity/talabalarga/alochi-talabalar")}>
                        {t("Iqtidorlilar va chempionlar")}
                    </li>
                    <li onClick={() => navigate("/activity/talabalarga/stipendiantlar")}>
                        {t("Stipendiantlar")}
                    </li>
                    <li className={classes.active}>
                        {t("Bizning bitiruvchilar")}
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Bitiruvchilar;
